<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ProgressSteps from "@/components/website/ProgressSteps.vue";
import WebsiteCard from "@/components/website/agency/partials/WebsiteCard.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import KitBenefits from "@/components/website/agency/partials/ui/KitBenefits.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import {computed, onMounted} from "vue";
import {useStore} from "vuex";

const emit = defineEmits(['back']);
const store = useStore();

const fetching = computed(() => store.getters['agencyWebsite/fetchingProducts']);
const agencyProduct = computed(() => store.getters['agencyWebsite/agencyProduct']);
const agencyPlusKitProduct = computed(() => store.getters['agencyWebsite/agencyPlusKitProduct']);

onMounted(async () => {
  if (Object.keys(store.getters['agencyWebsite/agencyProduct']).length === 0) {
    await store.dispatch('agencyWebsite/fetchProducts');
  }
});

const handleBack = () => {
  store.dispatch('agencyWebsite/setErrors', {});

  emit('back');
}

const hikeDIYInclusions = [
  {
    ticked: true,
    description: 'Full access to the website SEO toolset',
  },
  {
    ticked: true,
    description: 'Full access to the Google Business Profile toolset',
  },
  {
    ticked: false,
    description: 'Includes Kit to manage everything for you',
  },
]

const agencyPlusKitProductInclusions = [
  {
    ticked: true,
    description: 'Full access to the website SEO toolset',
  },
  {
    ticked: true,
    description: 'Full access to the Google Business Profile toolset',
  },
  {
    ticked: true,
    description: 'Includes Kit to manage everything for you',
    highlight: true,
  },
]

</script>

<template>
  <LoadingBlock v-if="fetching" />
  <div
    v-else
    class="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-2xl tw-text-center tw-max-w-default-container tw-mx-auto tw-py-6 tw-min-h-[680px]"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-6 tw-gap-8 tw-max-w-[1040px] tw-w-3/4">
      <div class="md:tw-flex-row tw-flex tw-flex-col tw-gap-6 tw-justify-center tw-w-full">
        <WebsiteCard
          :key="agencyProduct.id"
          :product="agencyProduct"
          :alternate-has-discount="!! agencyProduct.discountPrice"
          :inclusions="hikeDIYInclusions"
        >
          <template #product-name>
            Hike - Do It Yourself
          </template>

          <template #description>
            Choose this if you want to manage your client’s SEO yourself using Hike’s tools.
          </template>
        </WebsiteCard>

        <WebsiteCard
          v-if="agencyPlusKitProduct"
          :key="agencyPlusKitProduct.id"
          :product="agencyPlusKitProduct"
          :alternate-has-discount="!! agencyPlusKitProduct.discountPrice"
          :inclusions="agencyPlusKitProductInclusions"
          recommended
        >
          <template #product-name>
            <div class="tw-flex tw-gap-4 tw-justify-center tw-items-center tw-text-primary">
              <KitIcon class="!tw-h-12 !tw-w-12" /> Hike + Kit - Done For You
            </div>
          </template>

          <template #description>
            Choose this if you want Kit to manage your clients SEO using Hike's tools
          </template>

          <template #additional-info>
            <KitBenefits />
          </template>
        </WebsiteCard>
      </div>

      <div class="tw-flex tw-w-full">
        <DefaultButton
          variant="primary-inverted"
          @click="handleBack"
        >
          Back
        </DefaultButton>
      </div>

      <div class="tw-flex tw-flex-col">
        <ProgressSteps :current-step="3" />
      </div>
    </div>
  </div>
</template>
